<template>
    <v-app>
        <v-main class="app">
            <CommonSnackbar />
            <router-view />
        </v-main>
    </v-app>
</template>

<script>
import { onAuthStateChanged } from 'firebase/auth';
import CommonSnackbar from './components/CommonSnackbar.vue';
import { auth } from './config/firebase';

export default {
    name: 'App',
    components: {
        CommonSnackbar,
    },
    data: () => ({
        user: null,
        authLoading: true,
    }),
    created() {
        onAuthStateChanged(auth, (user) => {
            this.user = user || null;
            this.authLoading = false;
        });
    },
    mounted() {
        window.addEventListener('popstate', () => {
            this.$store.dispatch('updateIsGeneratePopup', false)
        })
    },
}
</script>

<style>
@font-face {
    font-family: 'Inter';
    src: url('@/assets/fonts/Inter.ttf');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'OverpassMono';
    src: url('@/assets/fonts/OverpassMono.ttf');
    font-weight: normal;
    font-style: normal;
}

html {
    overflow: hidden !important;
}

.app {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: var(--default-background);
    background-color: black;
    background-size: cover;
    font-family: sans-serif, 'Inter';
}

:root {
    --primary-font-color: #171717;
    --secondary-font-color: #FFFFFF;
    --light-grey-color: #A3A3A3;
    --dark-grey-color: #404040;
    --primary-gradient: linear-gradient(90deg, #ff00c3, #FF0A19, #FF7800);
    --primary-gradient-bar: linear-gradient(90deg, #ff00c37a, #FF0A197a, #FF78007a);
    --primary-gradient-bar-with-black: linear-gradient(90deg, #00000070, #00000070),
        var(--primary-gradient-bar);
    --primary-gradient-with-black: linear-gradient(90deg, #00000070, #00000070),
        var(--primary-gradient);
    --primary-gradient-with-white: linear-gradient(90deg, #FFFFFF33, #FFFFFF33),
        var(--primary-gradient);

    --default-background: url('@/assets/images/comms-ai-background.png');
    --dark-background: url('@/assets/images/comms-ai-dark-background.png');

    --title-font-size: 32px;
    --header-font-size: 24px;
    --normal-font-size: 16px;
    --small-font-size: 12px;
}


button:disabled {
    cursor: not-allowed !important;
    opacity: 0.7;
}

.required {
    color: red;
}

.loader-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5em;
    width: 100%;
    height: 100%;
    color: white;
}

.loader-container.black {
    color: black !important;
}
</style>
